// Initial state is the place you define all initial values for the Redux store of the feature.
// In the 'standard' way, initialState is defined in reducers: http://redux.js.org/docs/basics/Reducers.html
// But when application grows, there will be multiple reducers files, it's not intuitive what data is managed by the whole store.
// So Rekit extracts the initial state definition into a separate module so that you can have
// a quick view about what data is used for the feature, at any time.

// NOTE: initialState constant is necessary so that Rekit could auto add initial state when creating async actions.
const initialState = {
  selectedService:null,
  selectedServiceOnward:{
    coachLayoutJson:null,
    originStageDetails:null,
    destinationStageDetails:null,
    boardingStage:null,
    droppingStage:null,
    route:null
  },
  selectedServiceReturn:{
    coachLayoutJson:null,
    originStageDetails:null,
    destinationStageDetails:null,
    boardingStage:null,
    droppingStage:null,
    route:null
  },
  serviceList:null,
  serviceListReturn:null,
  getServiceListPending: false,
  getServiceListError: null,
  getSelectedServicePending: false,
  getSelectedServiceError: null,

  bookingDetailsOnward:{
    totalBookingAmount:0,
    netBookingAmount:0,
    discountAmount:0,
    selectedSeatsToBook:null,
    selectedSeatsNumbers:null,
    selectedSeatTypes:null
  },
  bookingDetailsReturn:{
    totalBookingAmount:0,
    netBookingAmount:0,
    discountAmount:0,
    selectedSeatsToBook:null,
    selectedSeatsNumbers:null,
    selectedSeatTypes:null
  },
  openNewSearch:false,
  showNewSearch:false,
  getTrainListPending: false,
  getTrainListError: null
};

export default initialState;



// WEBPACK FOOTER //
// ./src/features/pb-service-list/redux/initialState.js